//src/app/features/questionnaires/create/TaxRequestTarget/index.tsx
import { useUpdateMyProfileMutation } from 'app/services/user';
import Form from 'Components/Form';
import Spinner from 'Components/Spinner';
import { SubmitHandler } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { StepWizardChildProps } from 'react-step-wizard';
import { useAuth } from 'utils/AuthProvider';
import renderInput from 'utils/renderInput';
import WizardFooter from '../../components/WizardFooter';
import { errorToast } from 'Components/Notifications';
import {
  selectPrepareQuestionnaire,
  TaxRequestTargetState,
} from '../PrepareQuestionnaire/slice';
import { validationSchema } from './fields';

import useTaxRequestTargetFields from './useTaxRequestTargetFields';

export default function TaxRequestTarget(props: Partial<StepWizardChildProps>) {
  const dispatch = useDispatch();
  const { nextStep } = props;
  const { user } = useAuth();
  const [UpdateUserProfile] = useUpdateMyProfileMutation();
  const initialState = {
    ...useSelector(selectPrepareQuestionnaire),
    specializationId: user?.specialization?.id.toString() || null,
  };
  const { fields, isLoading: isFieldsLoading } = useTaxRequestTargetFields();

  const onSubmit: SubmitHandler<TaxRequestTargetState> = async (data) => {
    if (!user) return;

    if (data.specializationId) {
      await UpdateUserProfile({
        user: {
          ...user,
          specialization_id: +data.specializationId,
        },
      });
    }

    nextStep!();
  };

  return (
    <>
      {isFieldsLoading ? (
        <div className="mt-20">
          <Spinner />
        </div>
      ) : (
        <Form
          defaultValues={initialState}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {({ handleSubmit }) => (
            <div className="flex flex-col gap-6 h-full">
              <div className="md-max:mb-40">
                {fields.map(
                  (
                    input: IBaseField<keyof TaxRequestTargetState>,
                    i: number,
                  ) => (
                    <div key={i}>{renderInput(input)}</div>
                  ),
                )}
              </div>
              <WizardFooter
                nextStep={'Analyzing your Situation'}
                onNext={() =>
                  // Wrap handleSubmit with both onValid and onInvalid callbacks.
                  handleSubmit(onSubmit, () =>
                    errorToast('Please complete all required fields.'),
                  )()
                }
                isLoading={false}
              />
            </div>
          )}
        </Form>
      )}
    </>
  );
}
